import { Flex } from '@chakra-ui/react';

export function QuantityBadge({ quantity }: { quantity: number }) {
   const boxStyles = {
      height: '18px',
      paddingX: 1,
      backgroundColor: 'gray.200',
   };

   const borderStyles = {
      outline: '1px solid',
      outlineColor: 'gray.300',
      borderRadius: 'sm',
   };

   const textStyles = {
      fontSize: 'sm',
   };

   return (
      <Flex
         position="absolute"
         alignItems="center"
         justifyContent="center"
         insetEnd={0}
         top={0}
         transform="translate(25%, -25%)"
         {...boxStyles}
         {...borderStyles}
         {...textStyles}
         className="quantity"
      >{`×${quantity}`}</Flex>
   );
}
